<template>
  <el-dialog
    append-to-body
    v-dialogDrag
    title="选择试卷"
    class="mid-dialog"
    :visible.sync="pointProps.visible"
    :close-on-click-modal="false"
    @close="$emit('cancel')"
  >
    <div class="flex mb-10px mr-10px">
      <el-input
        size="small"
        class="mr-10px !w-50"
        placeholder="题目模糊搜索"
        maxlength="50"
        v-model="searchData.topic"
        clearable
      ></el-input>
      <el-select
        v-model="searchData.examType"
        size="small"
        class="mr-10px !w-50"
        placeholder="请选择题目类型"
        clearable
        filterable
        multiple
        collapse-tags
      >
        <el-option
          v-for="item in questionList"
          :key="item.code"
          :label="item.displayName"
          :value="item.code"
        ></el-option>
      </el-select>
      <el-button size="small" type="primary" @click="handleSearch()">搜索</el-button>
      <el-button size="small" type="primary" @click="resetText()">重置</el-button>
    </div>
    <el-table
      :data="dataList"
      border
      class="w-full mb-20px"
      :height="tableHeight"
      stripe
      v-loading="tableLoading"
      @selection-change="handleSelection"
      :row-key="getRowKey"
    >
      <el-table-column
        type="selection"
        :selectable="isDisabled"
        width="50"
        align="center"
        :reserve-selection="true"
      ></el-table-column>
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column label="题目及答案" prop="name"></el-table-column>
      <el-table-column
        label="题目配图"
        width="100"
        prop="topicIllustrated"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="题目类型" prop="examType" width="80" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ questionListMap(scope.row) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="tableSizeChange"
      @current-change="tableCurrentChange"
      :current-page.sync="pageConfig.SkipCount"
      :page-size.sync="pageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="totalCount"
      class="float-right mt-20px ml-10px"
    ></el-pagination>
    <div slot="footer" class="dialog-footer flex justify-center items-center">
      <div class="flex justify-center">
        <el-button type="primary" size="small" @click="submitForm">确定</el-button>
        <el-button @click="closeDialog" size="small">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { QuestionSourceApi } from '@wiz-api/exam-management'

const questionSourceApi = new QuestionSourceApi()
export default {
  name: 'choose-topic-origin-form',
  props: {
    /**
     * @description: 上传传递的参数
     * @param {控制弹窗显示隐藏} visible
     * @return {*}
     */
    pointProps: {
      type: Object,
      default: () => {
        return {
          visible: false,
        }
      },
    },
    // 已选题源集合
    taskIds: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      tableLoading: false,
      selectionData: [],
      dataList: [],
      searchData: {
        topic: '',
        examType: [],
      },
      totalCount: 0,
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
    }
  },
  mounted() {
    this.getList()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 120px)'
    },
  },
  methods: {
    // 重置
    resetText() {
      if (this.pageOrigin === 'exam') {
        this.searchData.topic = ''
      } else {
        this.searchData = this.$options.data().searchData
      }
      this.handleSearch()
    },
    getRowKey(row) {
      return row.id
    },
    // 禁用复选框 0禁用 1不禁用
    isDisabled(row) {
      if (this.taskIds?.length > 0 && this.taskIds.includes(row.id)) {
        return 0
      }
      return 1
    },
    // 页码改变
    tableSizeChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.getList()
    },
    // 页数改变
    tableCurrentChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.getList()
    },
    // 搜索
    handleSearch() {
      this.pageConfig.SkipCount = 1
      this.getList()
    },
    // 选中
    handleSelection(values) {
      this.selectionData = values
    },
    // 表单提交
    async submitForm() {
      if (this.selectionData?.length === 0) {
        this.$message({
          showClose: true,
          message: '请选择风险点数据',
          type: 'warning',
        })
        return
      }
      // 页面来源,pageOrigin未topic题库管理和培训管理，抛出当前数据；exam，教育管理，抛出特定的数据格式
      if (this.pageOrigin === 'topic') {
        const selectionData = _.map(this.selectionData, (item) => {
          return item
        })
        this.$emit('add-risk-point', selectionData)
      } else if (this.pageOrigin === 'exam') {
        // exam，教育管理，抛出特定的数据格式
        const selectionData = _.map(this.selectionData, (item) => {
          return item
        })
        this.$emit('add-type-question', selectionData)
      }

      // 点击确定后,清空选择数据
      this.selectionData = []
    },
    // 关闭弹窗
    closeDialog() {
      this.pointProps.visible = false
      this.$emit('cancel')
    },
    // 获取风险点列表
    async getList() {
      const data = {
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
        ...this.searchData,
      }
      this.tableLoading = true
      const [err, res] = await questionSourceApi.pagedListQuery(data)
      if (!err) {
        this.dataList = res.items
        this.totalCount = res.totalCount
      }
      this.tableLoading = false
    },
  },
}
</script>

<style scoped lang="scss"></style>
